import 'App.css';
import * as DataFormat from 'Common/Scripts';

const AmendContractDetailsColumns = () => [
	{ dataField: 'markingTeamId', text: 'Marking Team ID', hidden: true, csvExport: false },
	{ dataField: 'qualificationYear', text: 'Year', hidden: true },
	{ dataField: 'appointmentType', text: 'Type', hidden: true },
	{ dataField: 'markingTeamTitle', text: 'Marking Team Title', hidden: true },
	{ dataField: 'markingTeamCode', text: 'Code', hidden: true, csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell) },
	{
		dataField: 'amendmentNumber',
		text: 'Amendment Number',
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide',
		csvFormatter: DataFormat.replaceNullOrZeroWithEmptyString
	},
	{
		dataField: 'amendmentDate',
		text: 'Amendment Date',
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide',
		formatter: DataFormat.createTimeInput,
		csvFormatter: DataFormat.createTimeInput
	},
	{
		dataField: 'amendmentReasons',
		text: 'Amendment Reasons',
		headerClasses: 'th-title-td',
		formatter: DataFormat.amendmentReasonsFormat
	}
];

export default AmendContractDetailsColumns;
